<template>
  <v-card>
    <system-notification
      :content="notificationContent"
      :show-checkbox="true"
      :dont-show-again.sync="dontShowAgain"
      @close="closeModalNotification"
    />
  </v-card>
</template>

<script>
  import SystemNotification from '@/components/SystemNotification';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      SystemNotification,
    },

    computed: {
      ...mapGetters('userNotification', [
        'notificationContent',
        'dontShowAgain',
      ]),
    },

    methods: {
      closeModalNotification() {
        this.closeModalNotification();
      },
    },
  };
</script>
